import { PathWithId } from "@constellation-academy/epic-ui";
import { ExternalLicensePoolEditPath } from "../external-license-pool-edit/external-license-pool-edit.paths";

export class ExternalLicensePoolsPath extends PathWithId<typeof ExternalLicensePoolsPath> {
	static readonly pathKey = "externalLicensePools";
	static readonly pathName = "external-license-pools";
	static readonly idKey = "externalLicensePoolId";
	static readonly childPaths = [ExternalLicensePoolEditPath];
}
